import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/icons/icon_check.svg';
import _imports_1 from '@/assets/images/icons/icon_checked.svg';
var _hoisted_1 = {
  class: "action-sheet"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "action-sheet__label"
};
var _hoisted_4 = {
  class: "action-sheet__icon"
};
var _hoisted_5 = {
  src: _imports_0,
  alt: ""
};
var _hoisted_6 = {
  src: _imports_1,
  alt: ""
};
import { ref, computed, watch } from "vue";
import Common from "./Common.vue";
export default {
  __name: 'ActionSheet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    okText: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: String,
      default: ""
    },
    onOk: {
      type: Function,
      default: null
    }
  },
  emits: ["update:visible"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var show = computed({
      get: function get() {
        return props.visible;
      },
      set: function set(val) {
        emits("update:visible", val);
      }
    });
    var selectedValue = ref("");
    watch(function () {
      return props.visible;
    }, function (val) {
      if (val) {
        selectedValue.value = props.value;
      }
    });
    function ok() {
      var _props$onOk;
      (_props$onOk = props.onOk) === null || _props$onOk === void 0 || _props$onOk.call(props, selectedValue.value);
    }
    function cancel() {
      show.value = false;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Common, {
        visible: show.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        title: __props.title,
        "on-ok": ok,
        "on-cancel": cancel,
        "ok-text": __props.okText || _ctx.$t('confirm'),
        "show-close-btn": true,
        "without-cancel": true,
        "cancel-on-click-overlay": true
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.value,
              class: "action-sheet__option",
              onClick: function onClick($event) {
                return selectedValue.value = item.value;
              }
            }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_vShow, selectedValue.value !== item.value]]), _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_vShow, selectedValue.value === item.value]])])], 8, _hoisted_2);
          }), 128))])];
        }),
        _: 1
      }, 8, ["visible", "title", "ok-text"]);
    };
  }
};